import styled from '@emotion/styled';
import { tokens, Modal } from '@hotjar/hotsauce';

export const ModalStyles = {
  Body: styled(Modal.Body)`
    background: ${tokens.BRAND_COLORS.cobalt_100};
    height: 100%;
    padding: ${tokens.spacer.x2} ${tokens.spacer.x2} ${tokens.spacer.x8} ${tokens.spacer.x7};
    position: relative;
  `,
  Container: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 875px;
    width: 100%;
  `,
  PlansColumn: styled.div`
    flex-grow: 2;
  `,
  Illustration: styled.div`
    position: absolute;
    right: 0;
    top: ${tokens.spacer.x8};
  `,
  LogoutRow: styled.div`
    display: flex;
    flex-flow: row-reverse;
    padding-bottom: ${tokens.spacer.x1};
  `,
};
